import { Stats } from "../stats/stats";

export class updateData {
    stats:Stats;
    constructor (stats) {
        this.stats =  new Stats(stats);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/updateData.ts